import { Typography } from "antd"
import styled from "styled-components"

const { Text } = Typography

const SThumbBox = styled.div<{ $size: number; $borderRadius: number }>`
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  flex-shrink: 0;
  border-radius: ${(p) => p.$borderRadius}px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

const SThumbImg = styled.img<{ $rotation: number }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  ${(p) => p.$rotation && `transform: rotate(${p.$rotation}deg);`}
  transition: transform 0.2s;
`

interface SquareArtThumbProps {
  src?: string
  alt: string
  size: number
  borderRadius?: number
  rotation?: number
}

const SquareArtThumb = ({
  src,
  alt,
  size,
  borderRadius = 4,
  rotation = 0,
}: SquareArtThumbProps) => {
  if (!src?.trim()) {
    return (
      <SThumbBox $size={size} $borderRadius={borderRadius}>
        <Text
          type="secondary"
          style={{
            fontSize: size < 40 ? 8 : 10,
            lineHeight: 1,
            userSelect: "none",
            paddingLeft: 6,
          }}
        >
          No img
        </Text>
      </SThumbBox>
    )
  }

  return (
    <SThumbBox $size={size} $borderRadius={borderRadius}>
      <SThumbImg src={src} alt={alt} $rotation={rotation} />
    </SThumbBox>
  )
}

export default SquareArtThumb
